import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import { Box, DialogContent, DialogTitle, Dialog } from '@mui/material';
import { useLoadingContext } from '../../context/LoadingProvider/LoadingContext';

type Props = {
  open?: boolean;
};

function Loading({ open }: Props) {
  const { loading } = useLoadingContext();
  return (
    <Dialog aria-labelledby="loading-dialog" open={open || loading}>
      <DialogTitle id="loading-dialog">Daten werden geladen...</DialogTitle>
      <DialogContent id="loading-dialog">
        <Box display="flex" justifyContent="center" minHeight={100}>
          <CircularProgress />
        </Box>
      </DialogContent>
    </Dialog>
  );
}

export default Loading;
